<template>
  <div>
    <FilterItems :datasIn="highwaySections" @filtered="updatedDatas"></FilterItems>

    <catalog-table
      :tableHeaders="highwaySectionHeaders"
      :tableData="newDatas"
      :propsToSearch="highwaySectionSearchableProps"
      :actions="highwaySectionActions"
      :pageSize="25"
    >
      <template v-if="$can('add', 'Highway', 'highwaysection')" slot="search-toolbar-actions">
        <md-button class="md-success" @click="addHighwaySection">
          <span class="md-label">
            <md-icon class="material-icons">add</md-icon>
          </span>
          Agregar
        </md-button>
      </template>
    </catalog-table>
    <!-- -->
    <modal v-if="editModal" @close="editModalHide">
      <template slot="header">
        <h4 class="info-text">{{ editModalTitle }}</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="editModalHide"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <highway-section-edit
          :highwaySection="currentHighwaySection"
          @saved="updateHighwaySection"
          @error="hideEdit"
        ></highway-section-edit>
      </template>
    </modal>
  </div>
</template>

<script>
import catalogService from "@/services/catalog";
import { CatalogTable } from "@/components/";
import { Modal } from "@/components";
import HighwaySectionEdit from "./Edit";
import FilterItems from "./Filter";

const HSECTIONPATH = "highway/highwaysection";
const EDITMODALLABEL = "Editar tramo";
const ADDMODALLABEL = "Agregar tramo";

const highwaySectionHeaders = {
  name: "Nombre",
  highwayName: "Autopista",
  highwaySectionAttendantName: "Jefe de conservación",
  administrativeChieffName: "Jefe administrativo",
  start: "Km de inicio",
  end: "Km final",
};

export default {
  name: "HighwaySections",
  components: {
    CatalogTable,
    Modal,
    HighwaySectionEdit,
    FilterItems,
  },
  data() {
    return {
      highwaySections: [],
      newDatas: [],
      editModal: false,
      currentHighwaySection: {},
      editModalTitle: EDITMODALLABEL,
      highwaySectionHeaders,
      highwaySectionSearchableProps: Object.keys(highwaySectionHeaders),
      highwaySectionActions: [
        {
          icon: "edit",
          exe: this.editHighwaySection,
          showIf: () => this.$can("change", "Highway", "highwaysection"),
        },
        {
          icon: "close",
          exe: this.deleteHighwaySection,
          showIf: () => this.$can("delete", "Highway", "highwaysection"),
        },
      ],
    };
  },
  methods: {
    updatedDatas(datas) {
      this.newDatas = datas;
    },

    editModalHide() {
      this.editModal = false;
    },
    editHighwaySection(c) {
      this.editModalTitle = EDITMODALLABEL;
      this.currentHighwaySection = c;
      this.editModal = true;
    },
    deleteHighwaySection(c) {
      this.$confirmMessage({ title: "¿Esta seguro?" }, () => {
        return catalogService
          .delete(HSECTIONPATH, c, { source: this.highwaySections })
          .catch(this.$fireErrorResponse);
      });
    },
    updateHighwaySection({ original, updated }) {
      this.hideEdit();
      if (!original.id) {
        catalogService
          .create(HSECTIONPATH, updated, { source: this.highwaySections })
          .then((highwaySection) =>
            this.$successMessage({
              title: `Creado nuevo tramo: ${highwaySection.name}`,
            })
          )
          .catch(this.$fireErrorResponse);
      } else {
        catalogService
          .update(HSECTIONPATH, updated, original, {
            source: this.highwaySections,
          })
          .then(
            (highwaySection) =>
              this.$successMessage({
                title: `${highwaySection.name} fue actualizado.`,
              }),
            this.$fireErrorResponse
          );
      }
    },
    addHighwaySection() {
      this.editModalTitle = ADDMODALLABEL;
      this.currentHighwaySection = {};
      this.editModal = true;
    },
    hideEdit() {
      this.editModal = false;
    },
  },
  mounted() {
    catalogService
      .fetch(HSECTIONPATH, {
        config: { params: { expand: true } },
      })
      .then((highwaySections) => (this.highwaySections = highwaySections));
    catalogService.fetch("highway", { useStore: true });
    catalogService.fetch("highway/camp", { useStore: true });
    catalogService.fetch("common/states", { useStore: true });
  },
};
</script>

<style lang="css" scoped>
.catalog-action {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/HighwaySection/Index.vue